import { LeaseInterface, NormalizedFMSLeaseInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - ../../../../apps/server/src/API/Leases/Leases.Controller.ts
export class LeasesAPI {
  static async createLease(orgId: number, lease?: Partial<LeaseInterface>) {
    return APIService.Server.post<LeaseInterface>(`/leases/org/${orgId}/lease`, lease);
  }

  static async createLeases(orgId: number, leases?: Partial<LeaseInterface>[]) {
    return APIService.Server.post<LeaseInterface[]>(`/leases/org/${orgId}/leases`, leases);
  }

  static async getLease(orgId: number, leaseId: number, params?: { includeUnit?: boolean }) {
    return APIService.Server.get<LeaseInterface>(`/leases/org/${orgId}/lease/${leaseId}`, params);
  }

  static async updateLeases(orgId: number, leases: Partial<LeaseInterface>[]) {
    return APIService.Server.put<LeaseInterface[]>(`/leases/org/${orgId}/leases`, leases);
  }

  static async getLeasesByLocationId(orgId: number, locationId: number) {
    return APIService.Server.get<LeaseInterface[]>(`/leases/org/${orgId}/location/${locationId}`);
  }

  static async getLeasesByUserId(orgId: number, userId: number, includeUnit = false, includeInactive = true) {
    return APIService.Server.get<LeaseInterface[]>(
      `/leases/org/${orgId}/user/${userId}?includeUnit=${includeUnit}&includeInactive=${includeInactive}`,
    );
  }

  static async getLeasesByTenantId(orgId: number, tenantId: number) {
    return APIService.Server.get<LeaseInterface[]>(`/leases/org/${orgId}/tenant/${tenantId}`);
  }

  static async updateLease(orgId: number, locationId: number, leaseId: number, lease?: Partial<LeaseInterface>) {
    return APIService.Server.put<LeaseInterface>(`/leases/org/${orgId}/location/${locationId}/lease/${leaseId}`, lease);
  }

  static async deleteLease(orgId: number, locationId: number, leaseId: number) {
    return APIService.Server.delete<LeaseInterface>(`/leases/org/${orgId}/location/${locationId}/lease/${leaseId}`);
  }

  static async deleteLeases(orgId: number, leaseIds: number[]) {
    return APIService.Server.delete<LeaseInterface[]>(`/leases/org/${orgId}/leases`, null, leaseIds);
  }
}
